import create, {initializeAndRegisterHooks} from 'context/create' 
import hooks, * as resolves from './hooks'

const initialState = {
  subjects: undefined,
  downloadedContent: {},
  grades: undefined,
  units: undefined,
  unitsCourse: undefined
}

const id = 'Catalog'

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, hooks, resolves)})

export {context as default}
